import { createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../../api/services/auth";
import { clearAllLocalProgress } from "../../../api/services/lessonProgress";
import { LOGOUT } from "../../../utils/constants";

export const login = createAsyncThunk("auth/login", async (requestData) => {
  return await authService.login(requestData);
});

export const register = createAsyncThunk("auth/register", async (requestData) => {
  return await authService.register(requestData);
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: LOGOUT });
  const response = await authService.logout();
  clearAllLocalProgress();
  return response;
});

export const verifyEmail = createAsyncThunk(
  "auth/verify-email",
  async (requestData) => {
    return await authService.verifyEmail(requestData);
  }
);

export const resendVerification = createAsyncThunk(
  "auth/resend-verification",
  async (requestData) => {
    return await authService.resendVerification(requestData);
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgot-password",
  async (requestData) => {
    return await authService.forgotPassword(requestData);
  }
);

export const resetPassword = createAsyncThunk(
  "auth/reset-password",
  async (requestData) => {
    return await authService.resetPassword(requestData);
  }
);

export const refresh = createAsyncThunk("auth/refresh", async () => {
  return await authService.refresh();
});

export const getUserInfo = createAsyncThunk("auth/get-user-info", async () => {
  return await authService.getUserInfo();
});

export const updateProfile = createAsyncThunk("auth/update-profile", async (profileData) => {
  return await authService.updateProfile(profileData);
});

export const changePassword = createAsyncThunk("auth/change-password", async (passwordData) => {
  return await authService.changePassword(passwordData);
});

export const getUserStatistics = createAsyncThunk("auth/get-user-statistics", async () => {
  return await authService.getUserStatistics();
});

export const getUserAchievements = createAsyncThunk("auth/get-user-achievements", async () => {
  return await authService.getUserAchievements();
});

export const getUserDashboard = createAsyncThunk("auth/get-user-dashboard", async () => {
  return await authService.getUserDashboard();
});
